import React,{useEffect,useState} from 'react';

const emptyProfile={
  workspaceName:'',businessName:'',industry:'',businessSize:'',operatingModel:'',
  businessObjectives:'',strategicPriorities:'',painPoints:'',technologyLandscape:'',
  transformationInitiatives:'',additionalContext:'',
};

export default function Settings({ repository, onAIConfigChanged, identity }) {
  const [profile,setProfile]=useState(emptyProfile);
  const [profileUpdatedAt,setProfileUpdatedAt]=useState(null);
  const [status,setStatus]=useState('');
  const [ai,setAI]=useState({mode:'managed',provider:'gemini',model:'',customerKeyConfigured:false,managedAvailable:false});
  const [aiKey,setAIKey]=useState('');
  const [aiBusy,setAIBusy]=useState('');
  const [activeTab,setActiveTab]=useState('context');
  const [aiTest,setAITest]=useState({state:'idle',message:''});

  const load=async()=>{
      const result=await repository.getWorkspaceProfile();
      const raw=result?.profile||{};
      setProfile({...emptyProfile,...raw,workspaceName:result?.workspace?.name||identity?.workspace?.name||'My Workspace',businessName:raw.businessName||raw.organizationName||'',businessSize:raw.businessSize||raw.organizationSize||''});
      setProfileUpdatedAt(result?.updatedAt||null);
      try{setAI(await repository.getAISettings());}catch(_){}
  };
  useEffect(()=>{load();},[]);

  const saveProfile=async()=>{
    setStatus('Saving…');
    try{
      const result=await repository.saveWorkspaceProfile(profile);
      setProfileUpdatedAt(result?.updatedAt||new Date().toISOString());
      setStatus('Business context saved');
    }catch(e){setStatus(e.message||'Unable to save business context');}
  };

  const saveAI=async()=>{setAIBusy('save');setStatus('Saving AI settings…');try{const next=await repository.saveAISettings({...ai,apiKey:aiKey||undefined});setAI(next);setAIKey('');await onAIConfigChanged?.();setStatus('AI settings saved');}catch(e){setStatus(e.message||'Unable to save AI settings');}finally{setAIBusy('');}};
  const testAI=async()=>{
    setAIBusy('test');
    setAITest({state:'testing',message:'Testing AI connection…'});
    try{
      let current=ai;
      if(ai.mode==='customer'){
        current=await repository.saveAISettings({...ai,apiKey:aiKey||undefined});
        setAI(current);
        setAIKey('');
        await onAIConfigChanged?.();
      }
      const x=await repository.testAI();
      setAITest({state:'success',message:`Connected successfully · ${x.provider} · ${x.model}`});
    }catch(e){
      setAITest({state:'error',message:e.message||'AI connection test failed'});
    }finally{
      setAIBusy('');
    }
  };
  const set=(key)=>(e)=>setProfile(p=>({...p,[key]:e.target.value}));
  return <>
    <div className="page-head"><div><div className="eyebrow">Configuration</div><h1>Settings</h1><p>Business context and AI configuration.</p></div></div>

    {status && <div className="settings-status">{status}</div>}

    <div className="settings-tabs" role="tablist" aria-label="Settings sections">
      <button type="button" className={activeTab==='context'?'active':''} onClick={()=>setActiveTab('context')}>Business context</button>
      <button type="button" className={activeTab==='ai'?'active':''} onClick={()=>setActiveTab('ai')}>AI</button>
    </div>

    {activeTab==='context' && <section className="panel">
      <div className="panel-head"><div><h2>Business context</h2><p>Describe the business environment Process Advisor should understand when generating advisory recommendations.</p></div></div>
      <div className="panel-body">
        <div className="org-profile-grid">
          <label className="wide"><span>Workspace name</span><input value={profile.workspaceName} onChange={set('workspaceName')} placeholder="My Workspace"/></label>
          <label><span>Business / customer name</span><input value={profile.businessName} onChange={set('businessName')}/></label>
          <label><span>Industry</span><input value={profile.industry} onChange={set('industry')}/></label>
          <label><span>Business size</span><input value={profile.businessSize} onChange={set('businessSize')}/></label>
          <label><span>Operating model</span><input value={profile.operatingModel} onChange={set('operatingModel')}/></label>
          <label className="wide"><span>Business objectives</span><textarea value={profile.businessObjectives} onChange={set('businessObjectives')} rows="3"/></label>
          <label className="wide"><span>Strategic priorities</span><textarea value={profile.strategicPriorities} onChange={set('strategicPriorities')} rows="3"/></label>
          <label className="wide"><span>Pain points</span><textarea value={profile.painPoints} onChange={set('painPoints')} rows="3"/></label>
          <label className="wide"><span>Technology landscape</span><textarea value={profile.technologyLandscape} onChange={set('technologyLandscape')} rows="3"/></label>
          <label className="wide"><span>Transformation initiatives</span><textarea value={profile.transformationInitiatives} onChange={set('transformationInitiatives')} rows="3"/></label>
          <label className="wide"><span>Additional context</span><textarea value={profile.additionalContext} onChange={set('additionalContext')} rows="3"/></label>
        </div>
        <div className="settings-actions">
          <button className="pa-primary" onClick={saveProfile} >Save business context</button>
          {profileUpdatedAt && <span className="settings-saved-at">Last saved {new Date(profileUpdatedAt).toLocaleString()}</span>}
        </div>
      </div>
    </section>}

    {activeTab==='ai' && <section className="panel">
      <div className="panel-head"><div><h2>AI configuration</h2><p>Use the Process Advisor managed AI service or a workspace-specific provider key.</p></div><span className={`status-pill ${ai.mode==='managed'?(ai.managedAvailable?'success':'danger'):(ai.customerKeyConfigured?'success':'danger')}`}>{ai.mode==='managed'?(ai.managedAvailable?'Managed AI ready':'Managed AI not configured'):(ai.customerKeyConfigured?'Customer key configured':'API key required')}</span></div>
      <div className="panel-body">
        <div className="ai-mode-grid">
          <label className={`ai-mode-card ${ai.mode==='managed'?'active':''}`}><input type="radio" name="ai-mode" checked={ai.mode==='managed'} onChange={()=>setAI(v=>({...v,mode:'managed'}))}/><span><b>Managed by Process Advisor</b><small>The API uses the server-managed provider and key. No AI secret is sent to the browser.</small></span></label>
          <label className={`ai-mode-card ${ai.mode==='customer'?'active':''}`}><input type="radio" name="ai-mode" checked={ai.mode==='customer'} onChange={()=>setAI(v=>({...v,mode:'customer'}))}/><span><b>Use my own AI account</b><small>Your provider key is encrypted in the SaaS database and used only by the server.</small></span></label>
        </div>
        <div className="form-grid two ai-settings-grid">
          <label><span>Provider</span><select value={ai.provider||'gemini'} disabled={ai.mode==='managed'} onChange={e=>setAI(v=>({...v,provider:e.target.value,model:''}))}><option value="gemini">Google Gemini</option><option value="openai">OpenAI</option><option value="anthropic">Anthropic</option></select></label>
          <label><span>Model</span><input value={ai.model||''} disabled={ai.mode==='managed'} onChange={e=>setAI(v=>({...v,model:e.target.value}))} placeholder={ai.managedModel||'Model name'}/></label>
          {ai.mode==='customer'&&<label className="form-span-two"><span>API key</span><input type="password" value={aiKey} onChange={e=>setAIKey(e.target.value)} placeholder={ai.customerKeyConfigured?'API key already configured — leave blank to keep it':'Enter provider API key'}/></label>}
        </div>
        <div className="settings-actions">
          <button className="pa-primary" disabled={!!aiBusy} onClick={saveAI}>{aiBusy==='save'?'Saving…':'Save AI settings'}</button>
          <button className="pa-secondary" disabled={!!aiBusy} onClick={testAI}>{aiBusy==='test'?'Testing…':'Test AI connection'}</button>
        </div>
        {aiTest.state!=='idle' && <div className={`ai-test-result ${aiTest.state}`}>
          <b>{aiTest.state==='testing'?'Testing connection':aiTest.state==='success'?'AI connection successful':'AI connection failed'}</b>
          <span>{aiTest.message}</span>
        </div>}
      </div>
    </section>}

  </>;
}
